module.exports = __webpack_public_path__ + "img/locked-bonus.30543116.svg";